import { render, staticRenderFns } from "./SafeData.vue?vue&type=template&id=fa372cc6&scoped=true"
import script from "./SafeData.vue?vue&type=script&lang=js"
export * from "./SafeData.vue?vue&type=script&lang=js"
import style0 from "./SafeData.vue?vue&type=style&index=0&id=fa372cc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa372cc6",
  null
  
)

export default component.exports